import { Component, OnInit } from '@angular/core';
import {TopbarText} from '../../components/topbar/topbar.component';
import {LoginUser} from '../../models/user.model';

@Component({
  selector: 'app-userprofile',
  templateUrl: './userprofile.component.html',
  styleUrls: ['./userprofile.component.css']
})
export class UserprofileComponent implements OnInit {

  topbartext : TopbarText[] = [{key: "profile", displayText : "Profile"}];
  user : LoginUser=<LoginUser>JSON.parse(sessionStorage.getItem('currentUser'));

  constructor() { 
    console.log(this.user);
  }


  ngOnInit() {
  }

}
